/**
 * Escenario común de las pantallas de alta/recuperación (Alta.dc.html).
 *
 * Fondo "stage" (más oscuro que el canvas), barra superior con marca y
 * selector de tema, contenido centrado. Las tarjetas flotan con la sombra
 * larga del prototipo.
 */
import { Link } from 'react-router-dom';
import { ThemeToggle } from '../ui/ThemeToggle';
import { Icon, IconName } from '../ui/Icon';

export const CARD_SHADOW = { boxShadow: '0 40px 90px -55px rgba(0,0,0,.5)' };

/** Email pendiente de verificar: viaja de /registro a /revisa y /verificar. */
export const PENDING_EMAIL_KEY = 'kakuat-pending-email';

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-stage flex flex-col items-center transition-colors safe-area-top safe-area-bottom">
      <div className="w-full max-w-[1080px] flex items-center justify-between gap-2.5 px-4 pt-3.5 pb-2">
        <Link to="/login" className="flex items-center gap-2 no-underline text-ink">
          <span className="w-3 h-3 rounded-full bg-brand" />
          <span className="font-display font-black text-[19px] tracking-tight">kakuat</span>
        </Link>
        <ThemeToggle />
      </div>
      <div className="w-full flex-1 flex justify-center px-4 pb-10 pt-3">{children}</div>
    </div>
  );
}

export function MessageCard({
  icon,
  tone = 'brand',
  title,
  body,
  children,
}: {
  icon: IconName;
  tone?: 'brand' | 'signal';
  title: string;
  body: string;
  children?: React.ReactNode;
}) {
  return (
    <div
      className="w-full max-w-[520px] self-start mt-[2vh] bg-canvas border border-line-strong rounded-3xl px-7 py-9 sm:px-11 sm:py-12 text-center animate-rise"
      style={CARD_SHADOW}
    >
      <div
        className={`w-[82px] h-[82px] rounded-[22px] grid place-items-center mx-auto mb-6 ${
          tone === 'brand' ? 'bg-brand-soft text-brand' : 'bg-signal-soft text-signal'
        }`}
      >
        <Icon name={icon} size={40} strokeWidth={1.5} />
      </div>
      <h1 className="font-display font-extrabold text-[26px] sm:text-[30px] tracking-tight mb-3 leading-tight">
        {title}
      </h1>
      <p className="text-ink-2 text-[16px] leading-relaxed mx-auto mb-7 max-w-[40ch]">{body}</p>
      {children}
    </div>
  );
}
